import { Component, OnDestroy, OnInit} from '@angular/core';
import { SubscriptionUtil } from "src/app/_utilities/subscription";
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import { AssetService } from "src/app/_services/asset.service";
import { ErrorUtil } from "src/app/_utilities/error";
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";

@Component({
  selector: "app-update-component-confirm",
  templateUrl: "./update-component-confirm.component.html",
  styleUrl: "./update-component-confirm.component.scss",
  standalone: false,
})
export class UpdateComponentConfirmComponent extends SubscriptionUtil implements OnInit, OnDestroy
{
  translate: any;
  data: any;

  constructor(
    private languageServc: LanguageTranslateService,
    public modelRef: BsModalRef,
    private assetService: AssetService,
    private errorUtil: ErrorUtil,
    private spinner: NgxSpinnerService,
    private router: Router, private bsModalServc: BsModalService
  ) {
    super();
  }

  ngOnInit() {
    this.getLanguageData();
  }

  push(obs: any) {
    super.push(obs);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  getLanguageData() {
    // this.spinner.show()
    this.push(
      this.languageServc.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
        }
      }),
    );
  }

  onSubmit() {
    this.spinner.show();
    let address: boolean = this.data.addressChecked;
    let custodian: boolean = this.data.custodianChecked;
    let customer: boolean = this.data.customerChecked;
    let servicezone: boolean = this.data.servicezoneChecked;
    let assetstatus: boolean = this.data.assetstatusChecked;

    delete this.data.addressChecked;
    delete this.data.custodianChecked;
    delete this.data.customerChecked;
    delete this.data.servicezoneChecked;
    delete this.data.assetstatusChecked;

    if (this.data.from == "asset-edit") {
      this.push(this.assetService.editAsset(
          this.data,
          address,
          custodian,
          customer,
          servicezone,
          assetstatus,
        )
        .subscribe({
          next: (res: any) => {
            this.spinner.hide();
            if (res.status === 200 || res.status === 201) {
              this.errorUtil.setErrorMessage(
                200,
                this.translate?.general.messages.updatedSuccessfully,
                null,
                "success",
                3000,
              );

              this.bsModalServc.setDismissReason("update-confirmed");
              this.modelRef.hide();
            } else {
              var errorTitle = res.error.title;
              if (res.error.type == "dynamic-lang-error") {
                var data =
                  res.error.instance + ".validationBE." + res.error.detail;
                var message = this.languageServc.getNestedValue(
                  this.translate,
                  data,
                );
                errorTitle = message;
              }

              this.errorUtil.setErrorMessage(
                res.status,
                null,
                errorTitle,
                "error",
                2000,
              );
            }
          },
          error: (err) => {
            console.log(err);
            this.spinner.hide();
            const title = this.errorUtil.processErrorTitle(
              err.error,
              this.translate,
            );
            this.errorUtil.setErrorMessage(400, null, title, "error", 3000);
          },
        })
      );
    }
    else{
      //from asset view page while changing status
      this.spinner.show();
      this.push(this.assetService.updateAssetsStatus(this.data.assetstatusId,this.data.id, this.data.updateChildAssetsStatus).subscribe(
        (res: any) => {
          this.spinner.hide();
          if (res.message == "success") {
            this.errorUtil.setErrorMessage(
              200,
              this.translate?.general.messages.updatedSuccessfully,
              null,
              "success",
              2000
            );
                
            this.bsModalServc.setDismissReason("status-update-confirmed");
            this.modelRef.hide();
          } else {
            var errorTitle = res.error.title;
            if (res.error.type == "dynamic-lang-error") {
              var data = res.error.instance + ".validationBE." + res.error.detail;
              var message = this.languageServc.getNestedValue(
                this.translate,
                data
              );
              errorTitle = message;
            }

            this.errorUtil.setErrorMessage(
              res.status,
              null,
              errorTitle,
              "error",
              2000
            );
          }
        },
        (err) => {
          console.log(err);
          this.spinner.hide();
          const title = this.errorUtil.processErrorTitle(
            err.error,
            this.translate
          );
          this.errorUtil.setErrorMessage(400, null, title, "error", 3000);
        }
      ));
    }

  }
}
